import _ from "lodash";
import Immutable from "immutable";

import BlockUpdateVO from "../../vo/BlockUpdate.mjs";
import UIActions from "../../actions/UIActions";
import DocumentStore from "../../document/DocumentStore";
import { COMMANDS } from "../../document/commands";
import AppConstants from "../../constants/AppConstants";
import AssetUtils from "../../utils/AssetUtils";
import PexelsSelectHandler from "./PexelsSelectHandler";

class MediaSelectHandler {
  static selectMedia(
    /** String **/ elementId,
    /** Immutable.Map **/ element,
    /** Object **/ chooserConfig
  ) {
    let type = _.get(chooserConfig, "type", "image");
    let onSelect = _.get(chooserConfig, "onSelect");
    const activeTab = _.get(chooserConfig, "activeTab");

    let config = {
      btnLabel: "Select",
      mode: AppConstants.ASSET_LIBRARY_MODE_CHOOSER,
    };

    let extensionFilter = _.get(chooserConfig, "extensionFilter");

    if (extensionFilter) {
      config.filterExts = extensionFilter;
    }

    if (activeTab) {
      config.activeTab = activeTab;
    }

    switch (type) {
      case "image":
        config.title = "Select Image";
        config.filter = AppConstants.ASSET_TYPE_IMAGE;
        break;
      case "video":
        config.title = "Select Video";
        config.filter = AppConstants.ASSET_TYPE_VIDEO;
        break;
      case AppConstants.ELEMENT_TYPE_LOTTIE:
        config.title = "Select Lottie Animation";
        config.filter = AppConstants.ASSET_TYPE_LOTTIE;
        break;
      case "images":
        config.title = "Select Images";
        config.btnLabel = "Save";
        config.mode = AppConstants.ASSET_LIBRARY_MODE_GALLERY_CHOOSER;
        config.filter = AppConstants.ASSET_TYPE_IMAGE;

        let images = element.getIn(["content", "items"], false);

        if (images == false) {
          images = [];
        } else {
          images = images.toJS(); //convert to standard array;
        }

        config.galleryAssets = images;

        break;
    }

    if (onSelect) {
      config.onSelect = onSelect;
    } else {
      if (type === "image" && !extensionFilter) {
        config.stockPhotoOnSelect = (photo) => {
          PexelsSelectHandler.applyPhotoToElement(elementId, photo);
        };
      }

      config.onSelect = function (selection) {
        let propInfo = null;
        let update = new BlockUpdateVO();

        switch (type) {
          case "images":
            let images = Immutable.List([]);
            //Need to make sure list and assets within list are an Immutable Object
            selection.forEach(function (asset) {
              var img = asset;

              if (asset.asset_id) {
                img = AssetUtils.getGalleryImageAsset(asset);
              }

              images = images.push(Immutable.Map(img));
            }, this);

            propInfo = {
              name: "content.items",
              value: images,
              action: AppConstants.UPDATE_ACTION_SET,
            };

            break;
          case "video":
            propInfo = {
              name: "content",
              value: AssetUtils.getElementAsset(selection),
            };

            break;

          case AppConstants.ELEMENT_TYPE_LOTTIE:
            propInfo = {
              name: "content",
              value: AssetUtils.getElementAsset(selection),
            };

            break;

          case "image":
            const newImageType =
              selection.ext != AppConstants.ELEMENT_TYPE_SVG
                ? AppConstants.ELEMENT_TYPE_GRAPHIC
                : AppConstants.ELEMENT_TYPE_SVG;

            // SET, not the default merge: the old image's alt text (desc),
            // provider, and attribution must not carry over to the new one.
            propInfo = {
              name: "content",
              value: AssetUtils.getElementAsset(selection),
              action: AppConstants.UPDATE_ACTION_SET,
            };

            update.addPropUpdate(elementId, {
              name: "type",
              value: newImageType,
            });

            break;
        }

        if (propInfo) {
          update.addPropUpdate(elementId, propInfo);
          DocumentStore.dispatch({ type: COMMANDS.UPDATE_BLOCK, payload: update });
        }
      };
    }

    UIActions.toggleAssetChooser(config);
  }
}

export default MediaSelectHandler;
